import { MutationTree } from 'vuex';
import { WhiteListsState } from './types';

export const mutations: MutationTree<WhiteListsState> = {
    pushWhiteLists:(state, data) => {
        state.whiteLists = state.whiteLists.concat(data)
    },
    setWhiteLists:(state, data) => {
        state.whiteLists = data
    },
    setWhiteListItem:(state, data) => {
        state.whiteListItem = data
    },
};
